import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config/Constants";
import Box from "../../Box";

type BoxBlueWithHeaderProps = {
  children: React.ReactNode;
  label?: string;
};

const BoxBlueWithHeader = (props: BoxBlueWithHeaderProps) => {
  return (
    <Box
      bgColor={Colors.zirconApprox}
      borderColor={Colors.selagoApprox}
      boxShadow={"none"}
    >
      <BoxBlueHeader>{props.label && props.label}</BoxBlueHeader>
      {props.children}
    </Box>
  );
};

export default BoxBlueWithHeader;

const BoxBlueHeader = styled.div`
  font-family: "Poppins-bold";
  font-weight: 700;
  font-size: 1.125rem;
`;
